"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DeliveryCatalogEntity_1 = __importDefault(require("./Entity/DeliveryCatalogEntity"));
var DeliveryCatalogApi = /** @class */ (function () {
    function DeliveryCatalogApi(session) {
        this.deliveryCatalogEntity = new DeliveryCatalogEntity_1.default(session);
    }
    DeliveryCatalogApi.prototype.getProviders = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.getProviders(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.getFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.getFilters()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.getFiltersDetails = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.getFiltersDetails(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.toggleFavorites = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.toggleFavorites(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.getUsersFavorites = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.getUsersFavorites()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.sendEmailNotification = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.sendEmailNotification(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.getFleetById = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.getFleetById(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.getDeliveryById = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.getDeliveryById(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.getMerchantConnectionsList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.getMerchantConnectionsList()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.createMerchantConnection = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.createMerchantConnection(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.updateMerchantConnection = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.updateMerchantConnection(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.deleteMerchantConnection = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.deleteMerchantConnection(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.verifyMerchantConnectionCredentials = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.verifyMerchantConnectionCredentials(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DeliveryCatalogApi.prototype.pauseMerchantConnection = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deliveryCatalogEntity.pauseMerchantConnection(payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DeliveryCatalogApi;
}());
exports.default = DeliveryCatalogApi;
//# sourceMappingURL=DeliveryCatalogApi.js.map